var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.view == 'realizados')?_c('view-component',{attrs:{"show_btn_save":false,"check_permissions":false,"show_previus_days":false,"model_name":"pending_completed"},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('fechas',{attrs:{"model_name":"pending_completed"}})]},proxy:true}],null,false,857106459)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }